<template>
	<div class="sch-day">
		<div class="sch-dayTime">
			<span>{{ label }}</span>
		</div>
		<div class="sch-list">
			<div class="sch-listItem" v-for="(group, key) in items" :key="key">
				<div
					class="sch-session"
					:class="item.open === '0' ? 'sch-session_closed' : ''"
					v-for="item in group"
					:key="item.id"
					@click.self="item.open === '1' ? $emit('select', item) : ''"
					itemscope
					itemtype="https://schema.org/Event"
				>
					<meta itemprop="startDate" :content="item.date + 'T' + item.time_format" />
					<div class="sch-sessionLabel" itemprop="name">{{ item.name }}</div>
					<div
						class="sch-sessionPrice"
						v-if="item.price !== '0.00'"
						itemprop="offers"
						itemscope
						itemtype="https://schema.org/Offer"
					>
						<span itemprop="price" :content="item.price">{{ item.price }} руб.</span>
					</div>
					<popup v-if="selected === item.id" v-on:close="$emit('unselect')">
						<book :item="item"></book>
					</popup>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import helper from '@/plugins/helper.js';
import book from '@/components/schedule/book.vue';

export default {
	props: ['items', 'time', 'selected'],
	computed: {
		label() {
			return helper.timeFormat(this.time);
		},
	},
	components: { book },
};
</script>
